import { useHistory, useLocation } from 'react-router-dom';
import styles from './SuperCourses.module.scss';
import Footer from '../../../components/footer/Footer';
import { ProgramFragment, Unit } from '@api/graphql-codegen'
import UnitsView from '@src/components/dashboard-courses/unitsView/UnitsView';
import FooterPage from '@src/components/footer-page/FooterPage';

function CourseUnits() {
  const { state: { program: course } } = useLocation();
  const history = useHistory();

  const handleCancel = () => {
    history.push('/super/courses');
  };

  const handleEditUnit = (unit: Unit) => {
    history.push(`/super/units/edit/${unit.id}`);
  };

  return (
    <>
      <div className={styles.page}>
        <UnitsView handleCancel={handleCancel} handleEditUnit={handleEditUnit} course={course}/>
      </div>
      <FooterPage />
      {/* <Footer/> */}
    </>
  );
}

export default CourseUnits;
